import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RequestListItem } from 'app/profile/models/profile.model';
import { ProfileService } from 'app/profile/services/profile.service';
import { SupplierTaskService } from 'app/profile/services/supplier-task.service';
import { I18nService } from 'app/shared/services/i18n.service';
import { Subscription } from 'rxjs';
import { CancelRequestDialogComponent } from './cancel-request-dialog/cancel-request-dialog.component';
import { NameChangeFormComponent } from '../request-form/name-change-form/name-change-form.component';
import { AppSettings } from 'app/app.settings';
import { BaseComponent } from '../base.component';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-request-list',
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.scss']
})
export class RequestListComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input('supplierCode') set _supplierCode(val: string) { if (val && val.trim() != "") this.supplierCode = val; };
  @Output('onCancelSucceed') onCancelSucceedEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  supplierCode: string;
  getListSub: Subscription;
  requestList: RequestListItem[];
  isContactValidationPendingTaskErrorMessage: string = 'No edit functionality available as your organization\'s contacts have yet to be validated, you are not enrolled in Multi-Factor Authentication, critical data changes are pending review, or you have no user access to manage this data.';

  constructor(
    public translate: I18nService,
    private taskService: SupplierTaskService,
    private profileService: ProfileService,
    private router: Router,
    private config: AppSettings,
    private matDialog: MatDialog,
    private store: Store<SupplierState>,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initRequestList();
    this.PrimaryContactDocument(this.store, this.router, this.supplierCode, false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.initRequestList();
    }
  }

  ngOnDestroy(): void {
    this.getListSub?.unsubscribe();
  }

  initRequestList() {
    this.getListSub = this.profileService.getRequestListBySupplierCode(this.supplierCode).subscribe(
      res => {
        if (res?.length) {
          this.requestList = res;
          this.requestList?.forEach(x => {
            switch (x.requestType) {
              case "NameOrTINChange": {
                x.requestTypeDisplay = this.translate.get("Legal Name/ Tax ID Number Update");
                break;
              }
              case "EntityExtension": {
                x.requestTypeDisplay = this.translate.get("Entity Extension");
                break;
              }
              case "TPRM": {
                x.requestTypeDisplay = this.translate.get("Cyber Third-Party Risk Management");
                break;
              }
              case "MFA Enrollment": {
                x.requestTypeDisplay = this.translate.get("MFA Enrollment");
                break;
              }
              case "RRT": {
                x.requestTypeDisplay = this.translate.get("Risk Treatment");
                break;
              }
              case "StandardReassessment": {
                x.requestTypeDisplay = this.translate.get("Standard Reassessment");
                break;
              }
            }
          });
        } else {
          this.requestList = [];
        }
      }
    );
  }

  openTasks(request: any) {
    switch (request.requestType) {
      case "TPRM":
        window.open(`${this.config.SRM_UI_URL}tasks?taskTypeName=TPRM`, "_blank");
        break;
      case "RRT":
        window.open(`${this.config.SRM_UI_URL}tasks?taskTypeName=RRT`, "_blank");
        break;
      case "MFA Enrollment": {
        let task = this.requestList.find(x => x.requestId == request.requestId);
        window.open(`${this.config.SRM_UI_URL}tasks?taskTypeName=ContactValidation&taskId=${task.portalTaskId}`, "_blank");
        break;
      }
      case "StandardReassessment": {
        window.open(`${this.config.SRM_UI_URL}tasks?taskTypeName=Reassessment`, "_blank");
        break;
      }
      default: {
        this.router.navigate([`${this.supplierCode}`, "Onboarding", "Home"]);
        break;
      }
    }
  }

  openRequest(requestId: string, requestType: string, mode: string) {
    switch (requestType) {
      case "NameOrTINChange": {
        const dialogRef = this.matDialog.open(NameChangeFormComponent, {
          panelClass: ['sidepanel', 'animate__animated', 'animate__slideInRight'],
          width: '65%',
          height: '100%',
          minWidth: '770px',
          data: {
            supplierCode: this.supplierCode,
            requestId: requestId,
            mode: mode
          }
        });
        break;
      }
      case "MFA Enrollment": {
        let task = this.requestList.find(x => x.requestId == requestId);
        window.open(`${this.config.SRM_UI_URL}tasks?taskTypeName=ContactValidation&taskId=${task.portalTaskId}`, "_blank");
      }
    }
  }

  cancelRequest(requestId: string, requestType: string) {
    const dialogRef = this.matDialog.open(CancelRequestDialogComponent,
      {
        width: '500px',
        height: '300px',
        data: {
          supplierCode: this.supplierCode,
          requestId: requestId,
          requestType: requestType
        }
      }
    );
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.onCancelSucceedEmit.emit(true);
      }
    })
  }
}
